import React from 'react';

class DirectoryWindow extends React.Component {
  constructor() {
    super();

    this.state = {

    };
  }

  render() {
    let terminal;
    if(this.props.getTerminal()) {
      terminal = this.props.getTerminal().state.terminal;
    }

    let dir = ['/'];
    let content = '{}';

    if(terminal) {
      dir = terminal.currentDirectory;
      content = JSON.stringify(terminal.fs.ls(dir).content, null, 2);
    }

    return (
      <div className={`terminal`} onClick={this.focusText}>

        <div className="title-bar">
          <div className="button-area">
            <div>
              <span className="icon">X</span>
            </div>
            <div>
              <span className="icon">-</span>
            </div>
            <div>
              <span className="icon">Y</span>
            </div>
          </div>

          <div className="title-area">
            <div className="title-icon"></div>
            <div className="title-text">/{dir[dir.length - 1]}</div>
          </div>
        </div>

        <div className="content" ref="content">
          <div className="content-wrapper">
            <pre>
              { content }
            </pre>
          </div>
        </div>
      </div>
    );
  }
}

export default DirectoryWindow;


// WEBPACK FOOTER //
// ./src/DirectoryWindow.js